export default {
  items: [
    {
      title: true,
      name: 'Beheer'
    },
    {
      name: 'Dashboard',
      url: '/dash',
      icon: 'icon-speedometer'
    },
    {
      name: 'Units',
      url: '/units/',
      icon: 'fa fa-th-list'
    },
    {
      name: 'Complexen',
      url: '/complexen/',
      icon: 'fa fa-building'
    },
    {
      name: 'Relaties',
      url: '/settings/relaties',
      icon: 'fa fa-users',
      badge: {}
    },

    {
      title: true,
      name: 'Documenten & Keuringen'
    },
    {
      name: 'Documenten',
      url: '/documenten/' + new Date().getUTCFullYear().toString(),
      icon: 'fa fa-file-text-o',
      badge: {}
    },
    {
      name: 'Keuringsrapporten',
      url: '/keuringsrapporten',
      icon: 'fa fa-list-alt'
    },
    {
      name: 'Docparser',
      url: '/docparser/list/new',
      icon: 'fa fa-cogs',
      badge: {}
    },
    {
      name: 'Templates',
      url: '/templates',
      icon: 'fa fa-files-o',
      badge: {}
    },

    {
      title: true,
      name: 'Financieel'
    },
    {
      name: 'Facturen',
      url: '/facturatie',
      icon: 'fa fa-money',
      badge: {}
    },
    {
      name: 'Verkoop',
      url: '/verkoop/openstaand',
      icon: 'fa fa-handshake-o',
      badge: {}
    },

    {
      title: true,
      name: 'Planning & Operatie'
    },
    {
      name: 'Herinspecties',
      url: '/planning/herinspecties',
      icon: 'fa fa-calendar',
      badge: {}
    },
    {
      name: 'Liftmanagement',
      url: '/management',
      icon: 'fa fa-wrench',
      badge: {}
    },

    {
      title: true,
      name: 'Rapportage'
    },
    {
      name: 'KPI',
      url: '/kpi',
      icon: 'fa fa-tachometer',
      badge: {}
    },
    {
      name: 'Exports',
      url: '/export',
      icon: 'fa fa-file-excel-o',
      badge: {}
    },
    {
      name: 'Inventarisatie-export',
      url: '/export/inventarisatie',
      icon: 'fa fa-upload',
      badge: {}
    }
  ]
}
